import { CompositeStructure, ShoppingCartProduct } from 'src/app/models/shopping-cart/shopping-cart-product';
import { ShoppingCartProductAccessory } from 'src/app/models/shopping-cart/shopping-cart-product-accessory';
import { ShoppingCartProductInformation } from 'src/app/models/shopping-cart/shopping-cart-product-information';

export class QuotationRecord extends ShoppingCartProduct {
  previousQuotationRecordId: number;
  supplierName: string;
  UnitPurchasePriceHt: number;
  referenceElcia?: string;

  constructor(
    id: string,
    externalId: number,
    name: string,
    thumbnail: string,
    productCode: string,
    ean: string,
    quantity: number,
    unitPurchasePriceHt: number,
    unitPriceHt: number,
    discount: number,
    tva: number,
    unitEcoTax: number,
    informations: ShoppingCartProductInformation[],
    accessory: ShoppingCartProductAccessory[],
    orderNumber: string,
    supplierName: string,
    supplierSent: boolean,
    previousQuotationRecordId?: number,
    supplierSentLastDate?: Date,
    automaticSupplierSent?: boolean,
    composite?: CompositeStructure,
    referenceElcia?: string,
    index?: number
  ) {
    super(
      id,
      externalId,
      name,
      thumbnail,
      productCode,
      ean,
      quantity,
      unitPurchasePriceHt,
      unitPriceHt,
      discount,
      tva,
      unitEcoTax,
      informations,
      accessory,
      orderNumber,
      supplierName,
      supplierSent,
      supplierSentLastDate,
      automaticSupplierSent,
      composite,
      index
    );
    this.previousQuotationRecordId = previousQuotationRecordId;
    this.referenceElcia = referenceElcia;
  }
}
